<!-- test autocomplete off -->
<p-dialog [modal]="true"
          [focusOnShow]="false"
          [(visible)]="visible"
          [style]="{width: '57rem'}"
          [closable]="false"
          [resizable]="false"
          [draggable]="false"
          styleClass="custom-header-dialog">
  <ng-template #header>
    <div>
      <span class="p-dialog-title">{{ i18n?.i18nLng()['ADDLEAD'] }}</span>
    </div>
    <p-button icon="pi pi-times"
              [text]="true"
              [rounded]="true"
              styleClass="p-dialog-close-button"
              severity="secondary"
              [attr.aria-label]="i18n.i18nLng()['CLOSE']"
              (click)="cancelAddLead()"/>
  </ng-template>
  <div class="dialog-stepper">
    <p-stepper [(value)]="addLeadActiveStep" [linear]="true">
      <p-step-list>
        <p-step [value]="1">{{ i18n.i18nLng()['ADDLEADBASESTEP'] }}</p-step>
        <p-step [value]="2">{{ i18n.i18nLng()['ADDLEADCONTACTSTEP'] }}</p-step>
        <p-step [value]="3">{{ i18n.i18nLng()['ADDLEADPRODUCTSTEP'] }}</p-step>
        <p-step [value]="4">{{ i18n.i18nLng()['ADDLEADSUMMARYSTEP'] }}</p-step>
      </p-step-list>
    </p-stepper>
  </div>
  @switch (addLeadActiveStep) {
    @case (1) {
      <div class="grid pt-8">
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="lead-customer-name">{{ i18n.i18nLng()['CUSTOMERNAME'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   [pAutoFocus]="true"
                   autocomplete="off"
                   id="leadcustomer-name"
                   maxlength="120"
                   [(ngModel)]="leadFormData.name"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.name ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.name"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.name ? 'name-invalid-help' : null"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.name) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="name-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="organization-type">
              {{ i18n.i18nLng()['ORGANIZATIONTYPE'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-select [(ngModel)]="leadFormData.organisationType"
                      inputId="organization-type"
                      [options]="settingsProvider.organizationType"
                      [showClear]="true"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      (ngModelChange)="validateLeadData(addLeadActiveStep)"
                      [filter]="true"
                      filterBy="label"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['ORGANIZATIONTYPE']"
                      [attr.aria-invalid]="leadFormDataInvalidFlags?.type"
                      [attr.aria-describedby]="leadFormDataInvalidFlags?.type ? 'type-invalid-help' : null"
                      [ngClass]="leadFormDataInvalidFlags?.type ? 'ng-invalid ng-dirty' : null"/>
            @if (leadFormDataInvalidFlags?.type) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="type-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="legal-form">
              {{ i18n.i18nLng()['LEGALFORMLABEL'] }}
            </label>
            <p-select [(ngModel)]="leadFormData.legalForm"
                      inputId="legal-form"
                      [options]="settingsProvider.legalForm"
                      [showClear]="true"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      [filter]="true"
                      filterBy="label"
                      optionLabel="label"
                      optionValue="value"
                      class="w-full"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['LEGALFORMLABEL']"/>
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="lead-street-nr">{{ i18n.i18nLng()['STREETNR'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   id="lead-street-nr"
                   maxlength="100"
                   autocomplete="off"
                   [(ngModel)]="leadFormData.streetNr"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.streetNr ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.streetNr"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.streetNr ? 'street-nr-invalid-help' : null"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.streetNr) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="street-nr-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="address-line-2">{{ i18n.i18nLng()['ADDRESS2LABEL'] }}</label>
            <input pInputText
                   id="address-line-2"
                   maxlength="70"
                   autocomplete="off"
                   [(ngModel)]="leadFormData.addressLine2"
                   [required]="false"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   pSize="large"/>
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="lead-postal-code">{{ i18n.i18nLng()['POSTALCODE'] }}<sup class="sps-sup">*</sup></label>
            <p-inputmask
                inputId="lead-postal-code"
                [(ngModel)]="leadFormData.postalCode"
                (ngModelChange)="validateLeadData(addLeadActiveStep)"
                [autoClear]="false"
                styleClass="w-full"
                mask="99999"
                slotChar=""
                [required]="true"
                [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                [attr.aria-invalid]="leadFormDataInvalidFlags?.postalCode"
                [attr.aria-describedby]="leadFormDataInvalidFlags?.postalCode ? 'postal-code-invalid-help' : null"
                [ngClass]="leadFormDataInvalidFlags?.postalCode ? 'ng-invalid ng-dirty' : null"
                size="large"/>
            @if (leadFormDataInvalidFlags?.postalCode) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="postal-code-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="lead-city">{{ i18n.i18nLng()['CITY'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   autocomplete="off"
                   id="lead-city"
                   maxlength="70"
                   [(ngModel)]="leadFormData.city"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.city ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.city"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.city ? 'city-invalid-help' : null"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.city) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="city-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="email">{{ i18n.i18nLng()['EMAILADDRESS'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   id="email"
                   maxlength="255"
                   autocomplete="off"
                   [(ngModel)]="leadFormData.email"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.email ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.email"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.email ? 'email-invalid-help' : null"
                   (blur)="validateEmail()"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.email) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['INVALIDEMAILINFO'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="phone">{{ i18n.i18nLng()['PHONE'] }}</label>
            <input pInputText
                   id="phone"
                   maxlength="30"
                   autocomplete="off"
                   [(ngModel)]="leadFormData.phone"
                   [required]="false"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   pSize="large"/>
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="url">{{ i18n.i18nLng()['WEBSITEURL'] }}</label>
            <input pInputText
                   id="url"
                   maxlength="255"
                   autocomplete="off"
                   [(ngModel)]="leadFormData.url"
                   [required]="false"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [attr.aria-describedby]="'url-help'"
                   pSize="large"/>
            <small style="line-height: 1.5rem" role="contentinfo" id="url-help">{{ i18n.i18nLng()['WEBSITEURLINFO'] }}</small>
          </div>
        </div>
      </div>
    }
    @case (2) {
      <div class="grid pt-8">
        <div class="col-12 text-lg">
          {{ i18n.i18nLng()['PRIMARYCONTACTTITLE'] }}
        </div>
        <div class="col-12">
          <div class="flex flex-column gap-2 w-15rem">
            <label for="contact-title">
              {{ i18n.i18nLng()['TITLE'] }}
            </label>
            <p-select [(ngModel)]="contactPerson.title"
                      [pAutoFocus]="true"
                      inputId="contact-title"
                      [options]="settingsProvider.personTitle"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      optionLabel="label"
                      optionValue="value"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['TITLE']"/>
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="firstname">{{ i18n.i18nLng()['FIRSTNAME'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   id="firstname"
                   maxlength="70"
                   autocomplete="off"
                   [(ngModel)]="contactPerson.firstName"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.firstName ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.firstName"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.firstName ? 'firstname-invalid-help' : null"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.firstName) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="firstname-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="lastname">{{ i18n.i18nLng()['LASTNAME'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   id="lastname"
                   maxlength="70"
                   autocomplete="off"
                   [(ngModel)]="contactPerson.lastName"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.lastName ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.lastName"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.lastName ? 'lastname-invalid-help' : null"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.lastName) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="lastname-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="contact-email">{{ i18n.i18nLng()['EMAILADDRESS'] }}<sup class="sps-sup">*</sup></label>
            <input pInputText
                   id="contact-email"
                   maxlength="255"
                   autocomplete="off"
                   [(ngModel)]="contactPerson.email"
                   [required]="true"
                   (ngModelChange)="validateLeadData(addLeadActiveStep)"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   [ngClass]="leadFormDataInvalidFlags?.contactEmail ? 'ng-invalid ng-dirty' : null"
                   [attr.aria-invalid]="leadFormDataInvalidFlags?.contactEmail"
                   [attr.aria-describedby]="leadFormDataInvalidFlags?.contactEmail ? 'contact-email-invalid-help' : null"
                   pSize="large"/>
            @if (leadFormDataInvalidFlags?.contactEmail) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="contact-email-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-6">
          <div class="flex flex-column gap-2 w-full">
            <label for="contact-phone">{{ i18n.i18nLng()['PHONE'] }}</label>
            <input pInputText
                   id="contact-phone"
                   maxlength="30"
                   autocomplete="off"
                   [(ngModel)]="contactPerson.phone"
                   [required]="false"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   pSize="large"/>
          </div>
        </div>
        <div class="col-12">
          <div class="flex flex-column gap-2 w-15rem">
            <label for="contact-preference">
              {{ i18n.i18nLng()['CONTACTPREFERENCE'] }}
            </label>
            <p-select [(ngModel)]="contactPerson.contactPreference"
                      inputId="contact-preference"
                      [options]="settingsProvider.contactPreference"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                      optionLabel="label"
                      optionValue="value"
                      size="large"
                      appendTo="body"
                      [attr.aria-label]="i18n.i18nLng()['CONTACTPREFERENCE']"/>
          </div>
        </div>
      </div>
    }
    @case (3) {
      <div class="grid pt-8">
        <div class="col-12 text-lg">
          {{ i18n.i18nLng()['ADDLEADPRODUCTSTEP'] }}
        </div>
        <div class="col-12">
          <div class="flex flex-column gap-2 w-full">
            <label for="contact-preference">
              {{ i18n.i18nLng()['PAYMENTMETHODS'] }}<sup class="sps-sup">*</sup>
            </label>
            <p-multi-select inputId="product-interest"
                            [(ngModel)]="productInterest.paymentMethods"
                            [options]="settingsProvider.globalActivePaymentMethods()"
                            [required]="true"
                            [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                            (ngModelChange)="validateLeadData(addLeadActiveStep)"
                            [maxSelectedLabels]="10"
                            optionLabel="label"
                            optionValue="value"
                            class="w-full"
                            size="large"
                            appendTo="body"
                            [attr.aria-label]="i18n.i18nLng()['PAYMENTMETHODS']"
                            [attr.aria-invalid]="leadFormDataInvalidFlags?.paymentMethods"
                            [attr.aria-describedby]="leadFormDataInvalidFlags?.paymentMethods ? 'interest-invalid-help' : null"
                            [ngClass]="leadFormDataInvalidFlags?.paymentMethods ? 'ng-invalid ng-dirty' : null"/>
            @if (leadFormDataInvalidFlags?.paymentMethods) {
              <small style="line-height: 1.5rem" class="text-error" role="alert" id="interest-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
            }
          </div>
        </div>
        <div class="col-12 text-lg mt-2">
          <span>GiroCheckout</span>
        </div>
        <div class="col-12">
          <div class="flex flex-column gap-2 w-full">
            <label for="product-notes">
              {{ i18n.i18nLng()['YOURNOTES'] }}
            </label>
            <textarea pTextarea
                      id="product-notes"
                      maxlength="255"
                      rows="4"
                      fluid
                      style="resize: none"
                      [(ngModel)]="productInterest.notes"
                      [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                      [attr.aria-label]="i18n.i18nLng()['YOURNOTES']"
                      pSize="large">
            </textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="flex flex-column gap-2 w-full">
            <label for="campaign-code">{{ i18n.i18nLng()['CAMPAIGNCODE'] }}</label>
            <input pInputText
                   id="campaign-code"
                   maxlength="10"
                   autocomplete="off"
                   [(ngModel)]="productInterest.campaignCode"
                   [required]="false"
                   [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                   pSize="large"/>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="flex w-full text-lg">
            <label>{{ i18n.i18nLng()['CONTRACTCHANNEL'] }}<sup class="sps-sup">*</sup></label>
          </div>
        </div>
        <div class="col-12">
          <div class="flex w-full">
            {{ i18n.i18nLng()['CONTRACTINFO'] }}
          </div>
        </div>
        <div class="col-12 flex gap-2">
          <p-radio-button inputId="contract-sps"
                          value="CONTRACTBYSPS"
                          [(ngModel)]="productInterest.contractChannel"
                          (ngModelChange)="validateLeadData(addLeadActiveStep)"
                          [ngClass]="leadFormDataInvalidFlags?.contractChannel ? 'ng-invalid ng-dirty' : null"
                          [attr.aria-invalid]="leadFormDataInvalidFlags?.contractChannel"
                          [attr.aria-describedby]="leadFormDataInvalidFlags?.contractChannel ? 'contract-channel-invalid-help' : null">
          </p-radio-button>
          <label class="text-lg" for="contract-sps">{{ i18n.i18nLng()['CONTRACTBYSPS'] }}</label>
        </div>
        <div class="col-12 flex gap-2">
          <p-radio-button inputId="contract-partner"
                          value="CONTRACTBYPARTNER"
                          [(ngModel)]="productInterest.contractChannel"
                          (ngModelChange)="validateLeadData(addLeadActiveStep)"
                          [ngClass]="leadFormDataInvalidFlags?.contractChannel ? 'ng-invalid ng-dirty' : null"
                          [attr.aria-invalid]="leadFormDataInvalidFlags?.contractChannel"
                          [attr.aria-describedby]="leadFormDataInvalidFlags?.contractChannel ? 'contract-channel-invalid-help' : null">
          </p-radio-button>
          <label class="text-lg" for="contract-partner">{{ i18n.i18nLng()['CONTRACTBYPARTNER'] }}</label>
        </div>
        @if (leadFormDataInvalidFlags?.contractChannel) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="contract-channel-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
    }
    @case (4) {
      <div class="grid pt-8">
        <div class="col-12 text-lg text-primary font-bold">
          {{ i18n.i18nLng()['SUMMARY'] }}&nbsp;-&nbsp;E-Government
        </div>
        <div class="col-12 mt-3">
          <sps-data-view-table headerTitleKey="ADDLEADBASESTEP"
                               [tableData]="baseDataSummary"
                               [titleColumnWidth]="titleColumnWidth">
          </sps-data-view-table>
        </div>
        <div class="col-12 mt-3">
          <sps-data-view-table headerTitleKey="PRIMARYCONTACT"
                               [tableData]="contactDataSummary"
                               [titleColumnWidth]="titleColumnWidth">
          </sps-data-view-table>
        </div>
        <div class="col-12 mt-3">
          <sps-data-view-table headerTitleKey="ADDLEADPRODUCTSTEP"
                               [tableData]="productDataSummary"
                               [titleColumnWidth]="titleColumnWidth">
          </sps-data-view-table>
        </div>
        <div class="col-12 mt-3">
          <sps-data-view-table headerTitle="GiroCheckout"
                               [tableData]="giroCheckoutDataSummary"
                               [titleColumnWidth]="titleColumnWidth">
          </sps-data-view-table>
        </div>
      </div>
    }
  }
  <ng-template #footer>
    <div class="flex w-full align-items-center justify-content-between">
      <div class="text-sm">
        <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
      </div>
      <div class="flex gap-2">
        <p-button [label]="i18n.i18nLng()['CANCEL']" severity="secondary" (click)="cancelAddLead()"/>
        @if (addLeadActiveStep > 1) {
          <p-button [label]="i18n.i18nLng()['BACK']" icon="pi pi-arrow-left" [outlined]="true" (click)="previousLeadStep()"/>
        }
        @if (addLeadActiveStep === 4) {
          <p-button [label]="i18n.i18nLng()['SEND']" icon="pi pi-arrow-right" iconPos="right" [disabled]="!dataValid" (onClick)="sendAddLeadRequest()"/>
        } @else {
          <p-button [label]="i18n.i18nLng()['NEXT']" icon="pi pi-arrow-right" iconPos="right" [disabled]="!dataValid" (click)="nextLeadStep()"/>
        }
      </div>
    </div>
  </ng-template>
</p-dialog>
